import { useEffect } from 'react'

import { useNavigate } from 'react-router-dom'
import { handleBackButton, normalizeLanguage, resolveDeviceLanguage } from 'utils'
import { LanguagesEnum, LanguageTrackName } from 'common/enums/languages'
import { useAppInfo } from 'hooks/useAppInfo'
import { routes } from 'routes'

import IcArrowleft from '@interco/icons/orange/MD/ic_arrowleft'
import { Card, Icon, Text, Button } from '@interco/inter-toranja'
import { Button as ButtonUI } from '@interco/inter-ui/components/Button'
import { TrackData } from '@interco/track'

import { locales } from './data'

export function Lead() {
  const navigate = useNavigate()
  const { appInfo } = useAppInfo()
  const selectedLanguage = normalizeLanguage(resolveDeviceLanguage(appInfo), LanguagesEnum.PT_BR)

  const locale = locales[selectedLanguage]

  useEffect(() => {
    const productName = 'mortgage'
    const flow = 'landing_page'

    TrackData.log({
      product_name: productName,
      flow,
      screen_name: `${productName}/${flow}`,
      scenario: LanguageTrackName[selectedLanguage],
    })
  }, [selectedLanguage])

  return (
    <>
      <div className="flex flex-col gap-8 px-3 pb-[100px]">
        <div className="flex flex-col items-start justify-center">
          <ButtonUI type="button" variant="link" onClick={handleBackButton}>
            <IcArrowleft width={24} height={24} color="var(--color-icon-neutral-primary)" />
          </ButtonUI>
          <div className="px-3 flex flex-col gap-4">
            <Text as="h1" textType="title" textSize="large">
              {locale.header.title}
            </Text>
            <Text as="p" textType="body" textSize="medium" colorVariant="secondary">
              {locale.header.subtitle}
            </Text>
          </div>
        </div>

        <div className="px-3">
          <div className="py-4">
            <Text as="h2" textType="title" textSize="small">
              {locale.smartFinancing.title}
            </Text>
          </div>

          <Card>
            {locale.smartFinancing.items.map((item) => (
              <div key={item.label} className="flex items-center gap-4 py-4 px-6">
                <Icon asset={item.icon} size="medium" color="Icon/Neutral/Primary" />
                <Text as="p" textType="body" textSize="medium" textWeight="bold">
                  {item.label}
                </Text>
              </div>
            ))}
          </Card>
        </div>

        <div className="flex flex-col px-3">
          <div className="py-4">
            <Text as="h2" textType="title" textSize="small">
              {locale.whyChooseInter.title.split('Inter').map((part, index, arr) => (
                <span key={part}>
                  {part}
                  {index < arr.length - 1 && <span className="text-inter-primary">Inter</span>}
                </span>
              ))}
            </Text>
          </div>

          {locale.whyChooseInter.items.map((item) => (
            <div
              key={item.title}
              className="flex items-center gap-4 px-4 [&>*:first-child]:shrink-0"
            >
              <Icon asset={item.icon} size="medium" color="Icon/Neutral/Primary" />
              <div className="flex flex-col gap-1 py-4">
                <Text as="p" textType="body" textSize="medium" textWeight="bold">
                  {item.title}
                </Text>
                <Text as="p" textType="body" textSize="medium" colorVariant="secondary">
                  {item.description}
                </Text>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="fixed bottom-0 left-0 right-0 bg-[var(--neutral-theme)] p-6 border-t border-[var(--color-border-neutral-default)] max-h-[initial]">
        <Button
          type="button"
          hierarchy="primary"
          style={{ width: '100%' }}
          onClick={() => navigate(routes.leadForm)}
          label={locale.actionButton.title}
        />
      </div>
    </>
  )
}
